import { createFileRoute } from '@tanstack/react-router';
import { MarketplaceBrowse } from '@/components/marketplace';

export const Route = createFileRoute('/_dashboard/marketplace/')({
  component: MarketplacePage,
});

function MarketplacePage() {
  return <MarketplaceBrowse />;
}
